import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Checkbox,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import LoginImg from "../../../assets/loginImg.png";
import JusttawkLogo from "../../../assets/loginImg2.png";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInstance";

const centeredFlex = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const EmailPassLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const [consentChecked, setConsentChecked] = useState(true);
  const [consentError, setConsentError] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    addIpAddress();
  }, []);

  const addIpAddress = async () => {
    const res = await axios.get("https://api64.ipify.org/?format=json");
    setIpAddress(res.data.ip);
  };

  const loginUser = async (values) => {
    const data = {
      email: values.email.trim(),
      password: values.password.trim(),
      ip_address: ipAddress,

      // country: "",
      // dropoff: "",
    };
    try {
      const response = await axiosInstance.post(
        apiEndPointsConfig.loginByIdPass,
        data
      );
      console.log(response.data.memberId, "aaaasssss");
      localStorage.setItem("isNew", "2");
      localStorage.setItem("token", response?.data?.token);
      localStorage.setItem("userId", response?.data?.userId);
      localStorage.setItem("memberId", response?.data?.memberId);
      localStorage.setItem("username", response?.data?.name);
      localStorage.setItem("userRole", response?.data?.role);

      navigate("/dashboard"); // redirect after login
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.data?.message) {
        setLoginError("Invalid email or password");
      } else {
        setLoginError("Something went wrong. Please try again.");
      }
    }
  };

  const getQueryParam = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  useEffect(() => {
    const utm_source = getQueryParam("utm_source");
    const utm_campaign = getQueryParam("utm_campaign");
    const utm_medium = getQueryParam("utm_medium");

    if (utm_source) localStorage.setItem("source", utm_source);
    if (utm_medium) localStorage.setItem("medium", utm_medium);
    if (utm_campaign) localStorage.setItem("campaign", utm_campaign);
  }, [location.search]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      if (!consentChecked) {
        setConsentError(true);
        return;
      }
      loginUser(values);
    },
  });

  return (
    <Box>
      <Grid
        container
        sx={{
          overflow: "hidden",
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
        }}
      >
        {/* Left Section */}
        <Grid item xs={12} md={6.5}>
          <Box
            sx={{
              display: "flex",
              minHeight: "100vh",
              position: "relative",
              mt: { xs: "-150px", md: 0 },
            }}
          >
            <Box sx={{ display: "flex", width: "100%" }}>
              <Box
                sx={{
                  display: { xs: "none", md: "initial" },
                  width: "90%",
                  bgcolor: "#243e93",
                }}
              />
              <Box
                sx={{
                  display: { xs: "none", md: "initial" },
                  width: "10%",
                  bgcolor: "#3e55a0",
                }}
              />
            </Box>

            {/* Form Container */}
            <Container maxWidth="sm" sx={{ ...centeredFlex, p: 2 }}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 0, md: 5 },
                  borderRadius: 3,
                  width: "100%",
                  maxWidth: { xs: "90%", md: 500 },
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  border: "1px solid #dedede",
                  ml: { xs: 0, md: 5 },
                }}
              >
                <form onSubmit={formik.handleSubmit}>
                  <Box sx={{ p: { xs: "25px 25px 5px 25px", md: 0 } }}>
                    <Box sx={{ textAlign: "center", mb: 3 }}>
                      <Typography variant="h4" fontWeight="bold">
                        Hey! Good Choice.
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ mt: 0.5, fontWeight: 500 }}
                      >
                        Login with your credentials
                      </Typography>
                    </Box>

                    {/* Email */}
                    <Typography>Email*</Typography>
                    <TextField
                      id="email"
                      name="email"
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter your email"
                      fullWidth
                      value={formik.values.email}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setLoginError();
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />

                    {/* Password */}
                    <Typography>Password*</Typography>
                    <TextField
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter your password"
                      fullWidth
                      value={formik.values.password}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setLoginError();
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />


                    {/* Consent */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        mt: 1,
                        p: "10px 0",
                      }}
                    >
                      <Checkbox
                        checked={consentChecked}
                        onChange={(e) => {
                          setConsentChecked(e.target.checked);
                          setConsentError(false);
                        }}
                      />
                      <Typography sx={{ fontSize: "0.9rem" }}>
                        By submitting your details, you consent to receive
                        calls, emails, and messages from Justttawk on the
                        provided contact information.
                      </Typography>
                    </Box>
                    {consentError && (
                      <Typography
                        sx={{ color: "red", fontSize: "0.8rem", mt: 0.5 }}
                      >
                        You must accept the communication consent to proceed.
                      </Typography>
                    )}

                    {/* Button */}
                    <Button
                      variant="contained"
                      fullWidth
                      type="submit"
                      size="large"
                      disabled={!consentChecked}
                      sx={{
                        mt: 2,
                        bgcolor: "#243e93",
                        "&:hover": { bgcolor: "#152a60" },
                        py: 1.5,
                        textTransform: "capitalize",
                        borderRadius: "8px",
                      }}
                    >
                      Login
                    </Button>
                  </Box>
                </form>
                {loginError && (
                  <Typography sx={{ color: "red", fontSize: "0.9rem", mt: 1 }}>
                    {loginError}
                  </Typography>
                )}
              </Paper>
            </Container>
          </Box>
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={5.5}>
          <Box
            sx={{
              minHeight: "100%",
              p: 3,
              bgcolor: { xs: "#243E93E0", md: "white" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
              }}
            >
              <img
                src={JusttawkLogo}
                alt="Justtawk Logo"
                style={{ maxWidth: 210 }}
              />
            </Box>

            <Grid container>
              <Grid item md={10} xs={12}>
                <Box
                  sx={{
                    ...centeredFlex,
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "100%", md: 400 },
                      display: { xs: "none", md: "initial" },
                    }}
                  >
                    <img
                      style={{ width: "100%" }}
                      src={LoginImg}
                      alt="Login Illustration"
                    />
                  </Box>
                </Box>

                <Box sx={{ ...centeredFlex }}>
                  <Box
                    sx={{
                      maxWidth: 520,
                      textAlign: "center",
                      pb: { xs: "100px", md: "0" },
                    }}
                  >
                    <Typography
                      sx={{
                        color: { xs: "white", md: "black" },
                        fontSize: { xs: "1.5rem", md: "2.15rem" },
                        fontWeight: 900,
                      }}
                    >
                      Welcome to Justtawk
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        lineHeight: "25px",
                        mt: 1,
                        color: { xs: "white", md: "black" },
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      Affordable call center solution that helps your business
                      by seamlessly receiving and managing customer calls.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmailPassLogin;
